import { createClass as _createClass, classCallCheck as _classCallCheck } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import { parseMasterPlaylist } from "./master.js";
import { parseMediaPlaylist } from "./media.js";
import { getLines } from "./utils.js";
var M3U8Parser = /* @__PURE__ */ function() {
  function M3U8Parser2() {
    _classCallCheck(this, M3U8Parser2);
  }
  _createClass(M3U8Parser2, null, [{
    key: "parse",
    value: function parse() {
      var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      var parentUrl = arguments.length > 1 ? arguments[1] : void 0;
      if (!text.includes("#EXTM3U"))
        throw new Error("Invalid m3u8 file");
      var lines = getLines(text);
      if (M3U8Parser2.isMediaPlaylist(text)) {
        return parseMediaPlaylist(lines, parentUrl);
      }
      return parseMasterPlaylist(lines, parentUrl);
    }
  }, {
    key: "isMediaPlaylist",
    value: function isMediaPlaylist(text) {
      return text.includes("#EXTINF:") || text.includes("#EXT-X-TARGETDURATION:");
    }
  }]);
  return M3U8Parser2;
}();
export { M3U8Parser };
